import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { User } from '../../services';

export type UserState = {
  users: Partial<User>[];
  selectedUser: Partial<User> | null;
  selectedUserInCompany: Partial<User> | null;
  setSelectedUserInCompany: (user: Partial<User>) => void;
  setSelectedUser: (user: Partial<User>) => void;
  setUsers: (users: Partial<User>[]) => void;
  usersInCompany: User[];
  setUsersInCompany: (users: User[]) => void;
};

const useUserStore = create(
  persist<UserState>(
    set =>
      ({
        users: [],
        usersInCompany: [],
        selectedUser: null,
        selectedUserInCompany: null,
        setSelectedUserInCompany: (user: Partial<User>) =>
          set({
            selectedUser: user,
          }),
        setSelectedUser: (user: Partial<User>) =>
          set({
            selectedUser: user,
          }),
        setUsers: (users: Partial<User>[]) =>
          set({
            users,
          }),
        setUsersInCompany: (users: User[]) =>
          set({
            usersInCompany: users,
          }),
      } as UserState),
    {
      name: '@tenGovUseUserStore',
    },
  ),
);

export default useUserStore;
